import React from 'react';
import './Common.css';

interface CardProps {
  title: string;
  value: string | number;
  icon?: string;
  color?: 'primary' | 'danger' | 'warning' | 'info';
  footer?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, value, icon, color = 'primary', footer }) => {
  const inner = (
    <>
      {icon && <span className="stat-card__icon">{icon}</span>}
      <div className="stat-card__content">
        <span className="stat-card__value">{value}</span>
        <span className="stat-card__title">{title}</span>
      </div>
    </>
  );

  if (footer) {
    return (
      <div className={`stat-card stat-card--${color} stat-card--with-footer`}>
        <div className="stat-card__main">{inner}</div>
        <div className="stat-card__footer">{footer}</div>
      </div>
    );
  }

  return <div className={`stat-card stat-card--${color}`}>{inner}</div>;
};

export default Card;
